import './GanttChartLineRenderer.css';
export var svgWrapperCSS = '_1o0vsma0-2-0-1';